"use strict";
// This is an auto-generated file. Please do not edit directly.
// For instructions on editing source .json files, please see:
// https://git.hubteam.com/HubSpot/UIComponents/tree/master/HubStyleTokens
// ***********************************************************************
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRANSPARENT = exports.TRANSPARENT_LIGHT = exports.TRANSPARENT_DARK = exports.INSTAGRAM = exports.YOUTUBE = exports.RSS = exports.PINTEREST = exports.XING = exports.GOOGLE = exports.FACEBOOK = exports.TWITTER = exports.LINKEDIN = exports.ALERT_SUCCESS = exports.ALERT_WARNING = exports.ALERT_DANGER = exports.FOCUS_RING_BASE = exports.BUTTON_DISABLED_TEXT = exports.BUTTON_DANGER_HOVER_FILL = exports.BUTTON_TERTIARY_LIGHT_HOVER_FILL = exports.BUTTON_TERTIARY_LIGHT_TEXT = exports.BUTTON_SECONDARY_ACTIVE_FILL = exports.BUTTON_SECONDARY_HOVER_FILL = exports.BUTTON_SECONDARY_TEXT = exports.BUTTON_PRIMARY_HOVER_FILL = exports.LINK_HOVER = exports.CHART_DARK_PURPLE = exports.CHART_PURPLE = exports.CHART_BLUE = exports.CHART_AQUA = exports.CHART_GREEN = exports.CHART_YELLOW = exports.CHART_ORANGE = exports.CHART_RED = exports.MONOLITH = exports.OLAF = exports.GYPSUM = exports.CIRRUS = exports.KOALA = exports.GREAT_WHITE = exports.BATTLESHIP = exports.FLINT = exports.EERIE = exports.SLINKY = exports.HEFFALUMP = exports.OBSIDIAN = exports.PANTERA = exports.FLAT_EARTH = exports.OZ_LIGHT = exports.OZ_MEDIUM = exports.OZ_DARK = exports.OZ = exports.THUNDERDOME_LIGHT = exports.THUNDERDOME_MEDIUM = exports.THUNDERDOME_DARK = exports.THUNDERDOME = exports.NORMAN_LIGHT = exports.NORMAN_MEDIUM = exports.NORMAN_DARK = exports.NORMAN = exports.CANDY_APPLE_LIGHT = exports.CANDY_APPLE_MEDIUM = exports.CANDY_APPLE_DARK = exports.CANDY_APPLE = exports.MARIGOLD_LIGHT = exports.MARIGOLD_MEDIUM = exports.MARIGOLD_DARK = exports.MARIGOLD = exports.LORAX_LIGHT = exports.LORAX_MEDIUM = exports.LORAX_DARK = exports.LORAX = exports.SORBET_LIGHT = exports.SORBET_MEDIUM = exports.SORBET_DARK = exports.SORBET = exports.CALYPSO_LIGHT = exports.CALYPSO_MEDIUM = exports.CALYPSO_DARK = exports.CALYPSO = void 0;
var CALYPSO = '#00a4bd';
exports.CALYPSO = CALYPSO;
var CALYPSO_DARK = '#0091ae';
exports.CALYPSO_DARK = CALYPSO_DARK;
var CALYPSO_MEDIUM = '#7fd1de';
exports.CALYPSO_MEDIUM = CALYPSO_MEDIUM;
var CALYPSO_LIGHT = '#e5f5f8';
exports.CALYPSO_LIGHT = CALYPSO_LIGHT;
var SORBET = '#ff8f59';
exports.SORBET = SORBET;
var SORBET_DARK = '#e68250';
exports.SORBET_DARK = SORBET_DARK;
var SORBET_MEDIUM = '#ffc7ac';
exports.SORBET_MEDIUM = SORBET_MEDIUM;
var SORBET_LIGHT = '#fff3ee';
exports.SORBET_LIGHT = SORBET_LIGHT;
var LORAX = '#ff7a59';
exports.LORAX = LORAX;
var LORAX_DARK = '#e66e50';
exports.LORAX_DARK = LORAX_DARK;
var LORAX_MEDIUM = '#ffbcac';
exports.LORAX_MEDIUM = LORAX_MEDIUM;
var LORAX_LIGHT = '#fff1ee';
exports.LORAX_LIGHT = LORAX_LIGHT;
var MARIGOLD = '#f5c26b';
exports.MARIGOLD = MARIGOLD;
var MARIGOLD_DARK = '#dbae60';
exports.MARIGOLD_DARK = MARIGOLD_DARK;
var MARIGOLD_MEDIUM = '#fae0b5';
exports.MARIGOLD_MEDIUM = MARIGOLD_MEDIUM;
var MARIGOLD_LIGHT = '#fef8f0';
exports.MARIGOLD_LIGHT = MARIGOLD_LIGHT;
var CANDY_APPLE = '#f2545b';
exports.CANDY_APPLE = CANDY_APPLE;
var CANDY_APPLE_DARK = '#d94c53';
exports.CANDY_APPLE_DARK = CANDY_APPLE_DARK;
var CANDY_APPLE_MEDIUM = '#f8a9ad';
exports.CANDY_APPLE_MEDIUM = CANDY_APPLE_MEDIUM;
var CANDY_APPLE_LIGHT = '#fdedee';
exports.CANDY_APPLE_LIGHT = CANDY_APPLE_LIGHT;
var NORMAN = '#f2547d';
exports.NORMAN = NORMAN;
var NORMAN_DARK = '#d94c71';
exports.NORMAN_DARK = NORMAN_DARK;
var NORMAN_MEDIUM = '#f9aabe';
exports.NORMAN_MEDIUM = NORMAN_MEDIUM;
var NORMAN_LIGHT = '#fdedf2';
exports.NORMAN_LIGHT = NORMAN_LIGHT;
var THUNDERDOME = '#6a78d1';
exports.THUNDERDOME = THUNDERDOME;
var THUNDERDOME_DARK = '#5e6ab8';
exports.THUNDERDOME_DARK = THUNDERDOME_DARK;
var THUNDERDOME_MEDIUM = '#b4bbe8';
exports.THUNDERDOME_MEDIUM = THUNDERDOME_MEDIUM;
var THUNDERDOME_LIGHT = '#f0f1fa';
exports.THUNDERDOME_LIGHT = THUNDERDOME_LIGHT;
var OZ = '#00bda5';
exports.OZ = OZ;
var OZ_DARK = '#00a38d';
exports.OZ_DARK = OZ_DARK;
var OZ_MEDIUM = '#7fded2';
exports.OZ_MEDIUM = OZ_MEDIUM;
var OZ_LIGHT = '#e5f8f6';
exports.OZ_LIGHT = OZ_LIGHT;
var FLAT_EARTH = '#253342';
exports.FLAT_EARTH = FLAT_EARTH;
var PANTERA = '#2d3e50';
exports.PANTERA = PANTERA;
var OBSIDIAN = '#33475b';
exports.OBSIDIAN = OBSIDIAN;
var HEFFALUMP = '#425b76';
exports.HEFFALUMP = HEFFALUMP;
var SLINKY = '#516f90';
exports.SLINKY = SLINKY;
var EERIE = '#7c98b6';
exports.EERIE = EERIE;
var FLINT = '#99acc2';
exports.FLINT = FLINT;
var BATTLESHIP = '#cbd6e2';
exports.BATTLESHIP = BATTLESHIP;
var GREAT_WHITE = '#dfe3eb';
exports.GREAT_WHITE = GREAT_WHITE;
var KOALA = '#eaf0f6';
exports.KOALA = KOALA;
var CIRRUS = '#f2f5f8';
exports.CIRRUS = CIRRUS;
var GYPSUM = '#f5f8fa';
exports.GYPSUM = GYPSUM;
var OLAF = '#ffffff';
exports.OLAF = OLAF;
var MONOLITH = '#000000';
exports.MONOLITH = MONOLITH;
var CHART_RED = '#ea90b1';
exports.CHART_RED = CHART_RED;
var CHART_ORANGE = '#fea58e';
exports.CHART_ORANGE = CHART_ORANGE;
var CHART_YELLOW = '#f5c78e';
exports.CHART_YELLOW = CHART_YELLOW;
var CHART_GREEN = '#a2d28f';
exports.CHART_GREEN = CHART_GREEN;
var CHART_AQUA = '#51d3d9';
exports.CHART_AQUA = CHART_AQUA;
var CHART_BLUE = '#81c1fd';
exports.CHART_BLUE = CHART_BLUE;
var CHART_PURPLE = '#bda9ea';
exports.CHART_PURPLE = CHART_PURPLE;
var CHART_DARK_PURPLE = '#9784c2';
exports.CHART_DARK_PURPLE = CHART_DARK_PURPLE;
var LINK_HOVER = '#007a8c';
exports.LINK_HOVER = LINK_HOVER;
var BUTTON_PRIMARY_HOVER_FILL = '#ff8f73';
exports.BUTTON_PRIMARY_HOVER_FILL = BUTTON_PRIMARY_HOVER_FILL;
var BUTTON_SECONDARY_TEXT = '#ff7a53';
exports.BUTTON_SECONDARY_TEXT = BUTTON_SECONDARY_TEXT;
var BUTTON_SECONDARY_HOVER_FILL = '#fff8f6';
exports.BUTTON_SECONDARY_HOVER_FILL = BUTTON_SECONDARY_HOVER_FILL;
var BUTTON_SECONDARY_ACTIVE_FILL = '#ffebe6';
exports.BUTTON_SECONDARY_ACTIVE_FILL = BUTTON_SECONDARY_ACTIVE_FILL;
var BUTTON_TERTIARY_LIGHT_TEXT = '#506e91';
exports.BUTTON_TERTIARY_LIGHT_TEXT = BUTTON_TERTIARY_LIGHT_TEXT;
var BUTTON_TERTIARY_LIGHT_HOVER_FILL = '#e5eaf0';
exports.BUTTON_TERTIARY_LIGHT_HOVER_FILL = BUTTON_TERTIARY_LIGHT_HOVER_FILL;
var BUTTON_DANGER_HOVER_FILL = '#ff5962';
exports.BUTTON_DANGER_HOVER_FILL = BUTTON_DANGER_HOVER_FILL;
var BUTTON_DISABLED_TEXT = '#b0c1d4';
exports.BUTTON_DISABLED_TEXT = BUTTON_DISABLED_TEXT;
var FOCUS_RING_BASE = '#00d0e4';
exports.FOCUS_RING_BASE = FOCUS_RING_BASE;
var ALERT_DANGER = '#f04b51';
exports.ALERT_DANGER = ALERT_DANGER;
var ALERT_WARNING = '#fdf3e1';
exports.ALERT_WARNING = ALERT_WARNING;
var ALERT_SUCCESS = '#5967bc';
exports.ALERT_SUCCESS = ALERT_SUCCESS;
var LINKEDIN = '#0077b5';
exports.LINKEDIN = LINKEDIN;
var TWITTER = '#55acee';
exports.TWITTER = TWITTER;
var FACEBOOK = '#3b5998';
exports.FACEBOOK = FACEBOOK;
var GOOGLE = '#dd4b39';
exports.GOOGLE = GOOGLE;
var XING = '#026466';
exports.XING = XING;
var PINTEREST = '#bd081c';
exports.PINTEREST = PINTEREST;
var RSS = '#f26522';
exports.RSS = RSS;
var YOUTUBE = '#ff0000';
exports.YOUTUBE = YOUTUBE;
var INSTAGRAM = '#c13584';
exports.INSTAGRAM = INSTAGRAM;
var TRANSPARENT_DARK = 'rgba(0, 0, 0, 0)';
exports.TRANSPARENT_DARK = TRANSPARENT_DARK;
var TRANSPARENT_LIGHT = 'rgba(255, 255, 255, 0)';
exports.TRANSPARENT_LIGHT = TRANSPARENT_LIGHT;
var TRANSPARENT = 'rgba(0, 0, 0, 0)';
exports.TRANSPARENT = TRANSPARENT;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/HubStyleTokens/static-2.2456/js/colors.js
// module id = 10
// module chunks = 5 6 7